function Services() {
  return (
    <div className="page services">
      <section className="page-hero">
        <h1>Services</h1>
        <p>Pragmatic, modern engineering to launch, scale, and secure your business.</p>
      </section>

      <section className="section blue-cards">
        <div className="cards">
          <div className="card service-card blue">
            <div className="icon-circle">PE</div>
            <h3>Product Engineering</h3>
            <p>
              End‑to‑end web apps with React and Node. From MVPs to robust, scalable products.
            </p>
            <ul>
              <li>UX/UI, architecture, and implementation</li>
              <li>Iterative delivery with clear milestones</li>
              <li>Quality gates: reviews, tests, CI</li>
            </ul>
          </div>
          <div className="card service-card blue">
            <div className="icon-circle">CD</div>
            <h3>Cloud & DevOps</h3>
            <p>
              Automate delivery and keep systems observable, reliable, and cost‑efficient.
            </p>
            <ul>
              <li>CI/CD, containers, infrastructure as code</li>
              <li>Monitoring, logs, and on‑call readiness</li>
              <li>Scalable, secure deployments</li>
            </ul>
          </div>
          <div className="card service-card blue">
            <div className="icon-circle">DI</div>
            <h3>Data & Integrations</h3>
            <p>
              APIs and integrations that connect your product to the tools you use.
            </p>
            <ul>
              <li>REST/GraphQL APIs and webhooks</li>
              <li>Third‑party integrations and SSO</li>
              <li>Dashboards and analytics</li>
            </ul>
          </div>
          <div className="card service-card blue">
            <div className="icon-circle">SEC</div>
            <h3>Security & Compliance</h3>
            <p>
              Security baked into design, development, and operations—not bolted on.
            </p>
            <ul>
              <li>Authentication and authorization</li>
              <li>Secure coding, reviews, and dependencies</li>
              <li>Backups, SLOs, and disaster recovery</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="section process">
        <h2>How we work</h2>
        <ol className="steps">
          <li>
            <h4>1. Discover</h4>
            <p>Workshops to align on goals, users, scope, and success metrics.</p>
          </li>
          <li>
            <h4>2. Design</h4>
            <p>Architecture, UX flows, and delivery plan with milestones and estimates.</p>
          </li>
          <li>
            <h4>3. Build</h4>
            <p>Iterative development with demos, feedback loops, and quality checks.</p>
          </li>
          <li>
            <h4>4. Launch & Evolve</h4>
            <p>Production launch, monitoring, and continuous improvement.</p>
          </li>
        </ol>
      </section>

      <section className="section cta">
        <h2>Have a project in mind?</h2>
        <p>We can help refine scope, budget, and milestones.</p>
        <a href="/contact" className="cta-btn">Request a consultation</a>
      </section>
    </div>
  );
}

export default Services;


